var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.questions),function(question,index){return _c('review-question',{key:index,attrs:{"hide-change-links":_vm.hideChangeLinks,"question":question,"question-id":index,"is-resident":_vm.isVoterResident}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }